export function groupByDay(templates) {
  const byDay = {};
  templates.forEach((tpl) => {
    const d = tpl.dayOfMonth || 1;
    (byDay[d] = byDay[d] || []).push(tpl);
  });
  return Object.entries(byDay)
    .map(([d, txs]) => [Number(d), txs])
    .sort((a, b) => a[0] - b[0]);
}

export function computeForecast(templates, monthData, isDone) {
  const pending = [];
  const done = [];
  let pendingDebit = 0;
  let pendingCredit = 0;
  let totalDebit = 0;
  let totalCredit = 0;

  templates.forEach((tpl) => {
    const amt = Number(tpl.amount) || 0;
    if (tpl.type === 'debit') totalDebit += amt;
    else totalCredit += amt;
    if (isDone(tpl)) {
      done.push(tpl);
    } else {
      pending.push(tpl);
      if (tpl.type === 'debit') pendingDebit += amt;
      else pendingCredit += amt;
    }
  });

  const currentBalance = monthData?.stats?.personalBalance ?? 0;
  const forecastBalance = currentBalance - pendingDebit + pendingCredit;

  return {
    pending,
    done,
    pendingDebit,
    pendingCredit,
    totalDebit,
    totalCredit,
    currentBalance,
    forecastBalance,
  };
}
